import { FC } from 'react';
import {
  BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer,
} from 'recharts';
import { ChartEmptyState } from '../../AthleteInjuryCharts/charts/_shared/ChartEmptyState';
import { ITeamRecurrenceMetric } from '../../../../models/injury';
import {
  chartAxisTick,
  chartGridProps,
  chartTooltipContentStyle,
  chartTooltipItemStyle,
  chartTooltipLabelStyle,
} from '../../../../shared/charts/chartTheme';

interface Props {
  data: ITeamRecurrenceMetric | null;
}

export const TeamRecurrenceChart: FC<Props> = ({ data }) => {
  if (!data?.data?.length) return <ChartEmptyState />;

  const chartData = [...data.data]
    .sort((a, b) => b.recurrenceRate - a.recurrenceRate)
    .map((d) => ({
      pos: d.position ?? 'N/D',
      rate: Math.round(d.recurrenceRate * 100),
      total: d.totalInjuries,
    }));

  return (
    <ResponsiveContainer width="100%" height={200}>
      <BarChart data={chartData} margin={{ top: 4, right: 8, left: -20, bottom: 0 }}>
        <CartesianGrid {...chartGridProps} />
        <XAxis dataKey="pos" tick={chartAxisTick} />
        <YAxis tick={chartAxisTick} unit="%" domain={[0, 100]} />
        <Tooltip
          contentStyle={chartTooltipContentStyle}
          labelStyle={chartTooltipLabelStyle}
          itemStyle={chartTooltipItemStyle}
          formatter={(v, _, props) => [`${v}% (${props.payload.total} inf.)`, 'Tasso recidiva']}
        />
        {/* Recidiva = segnale di rischio -> tono warning, non un colore arbitrario */}
        <Bar dataKey="rate" fill="var(--c-warning)" radius={[4, 4, 0, 0]} />
      </BarChart>
    </ResponsiveContainer>
  );
};
